import SkapaList, { type ListProps } from "@ingka/list";

export const List = (props: ListProps) => {
  return <SkapaList prefix="saleslead__" {...props} />;
};
